function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { useFilter, useRegionsQuery } from "../../hooks";
import { RegionsManager } from "../../services";
import { State } from "../State/State";
var REGION_RULES = {
    eq: [
        "enabled"
    ],
    nilike: [
        "alias"
    ]
};
var regionsManager = new RegionsManager();
export var RegionsLoader = /*#__PURE__*/ memo(function RegionsLoader(param) {
    var children = param.children;
    var _useFilter = _sliced_to_array(useFilter(REGION_RULES, {
        alias: "test.",
        enabled: true
    }), 1), regionFilter = _useFilter[0];
    var regionQuery = useMemo(function() {
        return {
            where: regionFilter
        };
    }, [
        regionFilter
    ]);
    var _useRegionsQuery = useRegionsQuery(regionQuery, {
        skip: regionsManager.hasRegions()
    }), data = _useRegionsQuery.data, error = _useRegionsQuery.error, loading = _useRegionsQuery.loading;
    if (data.length) {
        regionsManager.setRegions(data);
    }
    return /*#__PURE__*/ _jsx(State, {
        "data-testid": "regions-loader",
        emptyStateMessage: "No regions available",
        errorMessage: error ? "Could not load regions data. Please try again later" : undefined,
        isData: regionsManager.hasRegions(),
        loading: loading,
        children: children
    });
});

//# sourceMappingURL=RegionsLoader.js.map